import {
  Box,
  Button,
  Flex,
  Heading,
  Spinner,
  Table,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import Flag from "react-world-flags";
import { GraphViewModel } from "../../../models/Dashboard";
import ShowMoreModal from "./ShowMoreModal";
import GraphModal from "./GraphModal";
import ProcessesModal from "./ProcessesModal";
import DataListItem from "./DataListItem";
import { crm } from "../../../theme";

const DataList = ({
  loading,
  isPrinting,
  graph,
  graphType,
  formatter,
  title,
  button,
}: {
  loading: boolean;
  isPrinting: boolean;
  graph: GraphViewModel | undefined;
  graphType: string;
  formatter: Intl.NumberFormat;
  title: string;
  button: string;
}) => {
  const {
    onOpen: onOpenShowAll,
    isOpen: isOpenShowAll,
    onClose: onCloseShowAll,
  } = useDisclosure();
  const {
    onOpen: onOpenGraph,
    isOpen: isOpenGraph,
    onClose: onCloseGraph,
  } = useDisclosure();

  return (
    <>
      {loading ? (
        <Flex
          justifyContent="center"
          alignItems="center"
          className="dashboard-card"
          minH="600px"
          width={{ base: "100%", md: "50%" }}
        >
          <Spinner size="xl" />
        </Flex>
      ) : (
        <Flex
          justifyContent="space-between"
          className="dashboard-card"
          width={{ base: "100%", md: "50%" }}
        >
          <Box mt="24px">
            <Heading size="md" mb="48px" fontWeight="semibold">
              {title}
            </Heading>
            <Flex flexDir="column" gap="24px">
              {(isPrinting ? graph?.values : graph?.values.slice(0, 10))?.map(
                (v) => {
                  return (
                    <DataListItem
                      key={v.label}
                      property={graph?.property ?? ""}
                      {...{ v, graphType, isPrinting, formatter }}
                    />
                  );
                },
              )}
            </Flex>
          </Box>
          {!isPrinting && (
            <Flex flexDir="column" w="100%" gap="12px" mt="24px">
              <Button
                onClick={onOpenShowAll}
                backgroundColor={crm.brand}
                _hover={{ backgroundColor: crm.brandDark }}
                color="white"
                borderRadius="10px"
                fontWeight="600"
                textTransform="none"
              >
                Visualizar {button.toLowerCase()}
              </Button>

              <Button
                onClick={onOpenGraph}
                variant="outline"
                backgroundColor="white"
                borderColor={crm.border}
                color={crm.text}
                _hover={{ bg: crm.brandSoft, borderColor: crm.brand }}
                borderRadius="10px"
                fontWeight="500"
                textTransform="none"
              >
                Gerar gráfico
              </Button>
            </Flex>
          )}
          <ShowMoreModal
            values={graph?.values ?? []}
            title={button}
            isOpen={isOpenShowAll}
            onClose={onCloseShowAll}
            property={graph?.property ?? ""}
            {...{ isPrinting, formatter, graphType }}
          />
          <GraphModal
            isOpen={isOpenGraph}
            onClose={onCloseGraph}
            {...{ graph, formatter, graphType }}
          />
        </Flex>
      )}
    </>
  );
};

export default DataList;
